import {ReactNode, useCallback, useState} from 'react'

type Props = {
  list: (close: () => void) => ReactNode
  initiator: ReactNode
}

export const Selector = ({list, initiator}: Props) => {
  const [shown, setShown] = useState(false)

  const show = useCallback(() => {
    setShown(true)
  }, [])

  const hide = useCallback(() => {
    setShown(false)
  }, [])

  return (
    <div className="relative">
      <div onClick={show}>{initiator}</div>
      {shown && (
        <>
          <div
            onClick={hide}
            className="fixed h-full w-full top-0 left-0 bg-black bg-opacity-50 flex items-center justify-center z-10"
          >
            <div className="d:hidden bg-white rounded-lg p-4">{list(hide)}</div>
          </div>
          <div className="hidden d:block absolute top-7 -left-4 bg-white rounded-lg p-4 z-10">{list(hide)}</div>
        </>
      )}
    </div>
  )
}
